"use client";

import { useEffect } from "react";

// 请在这里配置您的线上正式域名
const ALLOWED_DOMAINS = ["localhost", "127.0.0.1", "wangwangzhushou.cc", "wangwang.com"];

export default function AntiClone() {
  useEffect(() => {
    // 1. 强制域名校验 (Domain Verification)
    const hostname = window.location.hostname;
    const isAllowed = ALLOWED_DOMAINS.some((domain) => hostname.includes(domain));
    
    // 如果发现是被别人下载到本地或者放到了其他盗版域名下运行
    if (!isAllowed) {
      // 销毁页面内容
      document.body.innerHTML = '<h1 style="color:red; text-align:center; padding:50px;">This website is protected. Unauthorized cloning detected.</h1>';
      // 可选：不断重定向到真实网站，或刷新导致对方卡死
      window.location.href = "https://wangwangzhushou.cc";
      return;
    }

    // 2. 禁用基础的开发者调试工具与右键
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      // 禁用 F12
      if (e.key === "F12") {
        e.preventDefault();
      }
      // 禁用 Ctrl+Shift+I (Windows/Linux) 或 Cmd+Opt+I (Mac) -> 打开开发者工具
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === "i") {
        e.preventDefault();
      }
      // 禁用 Ctrl+Shift+J / Cmd+Opt+J -> 打开控制台
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === "j") {
        e.preventDefault();
      }
      // 禁用 Ctrl+U / Cmd+U -> 查看网页源代码
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "u") {
        e.preventDefault();
      }
    };

    // 禁用拖拽和文本选中 (防复制)
    const handleSelectStart = (e: Event) => {
      e.preventDefault();
    };

    // 绑定事件
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    // document.addEventListener("selectstart", handleSelectStart); // 可选：如果影响正常文本复制可以注释掉

    // 清理事件
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      // document.removeEventListener("selectstart", handleSelectStart);
    };
  }, []);

  // 该组件不需要渲染任何可见的 UI
  return null;
}
